import ENV from '../constants/Env';
import { loader } from 'graphql.macro';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useStyles } from '../components/rides/rideFormStyles';
import MainLayout from '../components/layout/MainLayout';
import { Loading } from '../components/layout/Loading';
import { useSessionContext } from '../contexts/session-context';
import { useLazyQuery } from '@apollo/client';

const RIDE_QUERY_V4 = loader('../data/queries/RideQuery.graphql');

export function RebookPortalRide() {
  const { session } = useSessionContext();
  const history = useHistory();
  const classes = useStyles();
  const { rideId } = useParams<{
    rideId: string;
  }>();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const encounterId = searchParams.get('ehrEncounterId') ?? undefined;
  const isReturnTrip = searchParams.get('returnTrip') === 'true';

  const [getRide, { data, error, loading }] = useLazyQuery(RIDE_QUERY_V4, {
    fetchPolicy: 'network-only',
  });

  const portalBookFeatureFlag = session?.featureFlags?.includes(
    'dashboard_portal_book_ride',
  );

  useEffect(() => {
    if (rideId) {
      getRide({
        variables: { rideId: Number(rideId) },
      });
    }
  }, [rideId, getRide]);

  useEffect(() => {
    // Only redirect when featureFlags are loaded (not undefined)
    if (session?.featureFlags && !portalBookFeatureFlag) {
      history.replace({ pathname: '/' });
    }
  }, [portalBookFeatureFlag, session?.featureFlags, history]);

  if (loading) return <Loading />;
  if (error) return <MainLayout>Error loading ride</MainLayout>;
  if (!data?.ride) return <MainLayout>No ride found</MainLayout>;

  const isDelivery = data.ride.rideType === 'delivery';
  let transportType = data.ride.transportType;

  if (isDelivery) {
    if (transportType === 'companion') {
      transportType = 'delivery-companion';
    } else {
      transportType = 'delivery-wheelchair';
    }
  }

  const redirectUrl = new URL(`/rides/new/${transportType}`, ENV.portalUrl);
  redirectUrl.searchParams.set('rideId', rideId);
  redirectUrl.searchParams.set('embeddedInDashboard', 'true');

  if (isReturnTrip) {
    redirectUrl.searchParams.set('returnTrip', 'true');
  }

  if (encounterId) {
    redirectUrl.searchParams.set('ehrEncounterId', encounterId);
  }

  return (
    <MainLayout usePadding="no">
      <iframe
        data-test-id="portal-iframe"
        title="Rebook Portal Ride"
        src={redirectUrl.toString()}
        className={classes.iframe}
      />
    </MainLayout>
  );
}
